var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-voucher-area{margin:15rem .2rem 0;padding:1rem .5rem;border:.026667rem dotted #39c451;background:#fff}.add-voucher-area .add-voucher-icon{height:3rem;width:2.5rem;margin-right:.5rem;background:url(" + escape(require("../../../static/img/voucher-add.png")) + ") 50% no-repeat;background-size:contain}.register-des{color:#f24141;background:#eff2f5;margin:.5rem;padding:.2rem}.register-des .reminder{width:4rem;background:url(" + escape(require("../../../static/img/reminder.png")) + ") 0 no-repeat;background-size:.453333rem .453333rem;padding-left:1rem}.register-des p{padding-left:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f23ab6e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/residentHealthRecord/VoucherSelect.vue
// module id = 464
// module chunks = 0